module.exports = __webpack_public_path__ + "static/media/esboco3.d8b8213c.jpg";